
import { Clock, MapPin, Package } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { BookingDetails } from "@/hooks/bookings/types";
import { useBookingActions } from "@/hooks/bookings/useBookingActions";
import { useUserRoles } from "@/hooks/useUserRoles";
import BookingHeaderInfo from "./components/BookingHeaderInfo";
import AddressDisplay from "./components/AddressDisplay";
import PackageInfo from "./components/PackageInfo";
import AdminActionBadge from "./components/AdminActionBadge";
import BookingActions from "./components/BookingActions";
import { BookingStatusBadge } from "./utils/booking-status";
import { forwardRef } from "react";

interface BookingCardProps {
  booking: BookingDetails;
  onViewDetails: (booking: BookingDetails) => void;
  onCancelBooking: (bookingId: string) => void;
}

const BookingCard = forwardRef<HTMLDivElement, BookingCardProps>(({
  booking,
  onViewDetails,
  onCancelBooking
}, ref) => {
  const { roles } = useUserRoles();
  
  return (
    <Card ref={ref} className="w-full hover:shadow-md transition-shadow duration-200 bg-card border border-border mx-0 px-0">
      <CardContent className="p-6">
        <BookingHeaderInfo booking={booking} isAdmin={roles.isAdmin} />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <AddressDisplay 
            title="Collection" 
            address={booking.collection_address} 
            contacts={booking.collection_contacts} 
          />
          
          <AddressDisplay 
            title="Delivery" 
            address={booking.delivery_address} 
            contacts={booking.delivery_contacts} 
          />
        </div>

        <PackageInfo 
          parcels={booking.parcels} 
          totalParcelsCount={booking.total_parcels_count} 
          collectionDatetime={booking.collection_datetime} 
        />

        <BookingActions 
          booking={booking} 
          onViewDetails={onViewDetails} 
          onCancelBooking={onCancelBooking} 
        />
      </CardContent>
    </Card>
  );
});

BookingCard.displayName = "BookingCard";
export default BookingCard;
